'use client';
import React, {useRef, ReactElement, useEffect} from 'react';
import Slider, {Settings} from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './slick-override.scss';
import cn from './style.module.scss';
import useSlickState from '@hooks/useSlickState';

interface CustomCarouselProps
  extends Omit<Settings, 'nextArrow' | 'prevArrow'> {
  verticalMode?: boolean;
  prevArrow?: ReactElement;
  nextArrow?: ReactElement;
  arrowBlock?: boolean;
  children?: ReactElement | ReactElement[];
  arrowClassName?: string;
  previousClassName?: string;
  nextClassName?: string;
  selectedIndex?: number;
  totalCount?: number;
  itemPerSlide?: number;
}

export default function CustomCarousel({
  verticalMode = false,
  prevArrow,
  nextArrow,
  arrowBlock = false,
  children,
  arrowClassName,
  previousClassName,
  nextClassName,
  selectedIndex,
  totalCount = React.Children.count(children),
  itemPerSlide = 1,
  ...props
}: CustomCarouselProps) {
  const {sliderRef, values, mutations} = useSlickState(
    totalCount,
    itemPerSlide
  );

  const handleNext = () => {
    sliderRef.current?.slickNext();
  };

  const handlePrev = () => {
    sliderRef.current?.slickPrev();
  };

  const settings: Settings = {
    ...props,
    vertical: verticalMode,
    arrows: true,
    nextArrow: <></>,
    prevArrow: <></>,
  };

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(selectedIndex ?? 0, true);
    }
  }, []);
  return (
    <div className={cn.customSliderWrapper}>
      {arrowBlock && (
        <div className={`${cn.sliderCarouselArrows} ${arrowClassName}`}>
          <button
            className={`${cn.arrowsPrevious} ${previousClassName}`}
            onClick={handlePrev}>
            {prevArrow}
          </button>
          <button
            className={`${cn.arrowsNext} ${nextClassName}`}
            onClick={handleNext}>
            {nextArrow}
          </button>
        </div>
      )}
      <Slider
        ref={sliderRef}
        {...settings}
        beforeChange={mutations.handleBeforeChange}>
        {children}
      </Slider>
    </div>
  );
}